export default __webpack_public_path__ + "static/black-natural-cork-687010e38012a4e6cacb26a4cf3592a9.png";